//Google Analytics のイベント関連
$(document).ready(function () {
    'use strict';


    function initEvents(target) {
        //イベントの最初期化
        //現在は不要になった

    }

    //クリックイベントを初期化
    function initClickEvent() {

        $(document).on('click', 'a', function () {
            var $this = $(this);
            //親要素のclassも取得
            var $parent = $this.parent();
            var classes = $this.attr('class') || '';
            var parent_classes = $parent.attr('class') || '';
            var body = {
                'page_url': location.href.replace(location.hash, ""),
                'click_url': $this.attr('href'),
                'click_id': $this.attr('id'),
                'click_classes': classes + ' ' + parent_classes,
                'click_text': $this.text().trim(),
                'data': $this.data(),
            };

            navigator.sendBeacon(moko.ajaxurl + '?action=moko_record_click_log', JSON.stringify(body));
        });
    }



    //スクロールイベント
    function initScrollEvent() {
        var window_height = $(window).height();
        var $scroll_event_elements = $('.ga-event-scroll');
        $(window).on('scroll', function () {
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            scrollTop += window_height;
            var elem_position = $scroll_event_elements.position();
            $scroll_event_elements.each(function () {
                var $this = $(this);
                //console.log( this.event_seneded);
                if (!this.event_seneded) {
                    var top = $this.position().top;
                    //  console.log( 'event scroll', top, scrollTop );
                    if (top < scrollTop) {
                        var imp_type = 'scroll';
                        var imp_data = $this.data();
                        var imp_body = {
                            'page_url': location.href.replace(location.hash, ""),
                            'impression_type': imp_type,
                            'data': imp_data,
                        };
                        navigator.sendBeacon(moko.ajaxurl + '?action=moko_record_imp_log',
                            JSON.stringify(imp_body));

                        this.event_seneded = true;
                    }
                }
            });
        });
    }




    /**
     * 初期化処理
     **/
    initClickEvent();
    initScrollEvent();


    //外部へ開放するイベント
    /**
     * イベントの初期化:
     * DOMを再構築したときに呼び出す
     **/
    moko.initEvents = initEvents;


});
